<template>
  <div id="app" style="padding-top: 50px;">
    <div
      class="card"
      style="width: 98.50%; margin-left: 10px; margin-right: 10px; min-width: 300px;"
    >
      <div class="card-body">
        <h5 class="card-title">
          <i class="fab fa-line"></i>
          {{ $route.meta.title }}
        </h5>
        <hr />
        <div class="contianer">
          <h4>ขั้นตอนการสมัครรับการแจ้งเตือนผ่านไลน์</h4>
          <hr />
          <div class="row">
            <div class="col-sm-4    text-left">
              <p class="ml-5 mr-5">
                <b>&nbsp;&nbsp;&nbsp;&nbsp;ขั้นตอนที่ 1</b>
                SCAN QRCode หรือ คลิ๊กที่ปุ่มลงทะเบียนด้านล่างเพื่อเชื่อมต่อไลน์ของท่านเข้ากับระบบลงเวลาปฏิบัติงาน ( ให้ท่านเข้าสู่ระบบด้วยไอดีไลน์ที่ต้องการรับการแจ้งเตือน )
              </p>
              <div class="text-center">
                <qrcode-vue :value="$store.state.config.link_line_notify" :size="250" level="H"></qrcode-vue>
                <a
                  :href="$store.state.config.link_line_notify"
                  class="btn btn-link"
                >คลิก "Link ลงทะเบียน LINE"</a>
              </div>
              <p class="ml-5 mr-5">
                    <b>&nbsp;&nbsp;&nbsp;&nbsp;ขั้นตอนที่ 2 </b>
                        เข้าสู่ระบบด้วย Username และ Password Line ของท่าน
                </p>
                 <div class="text-center">
                    <img src="../assets/loginline.jpg" width="50%" style="text-align: center;">
                </div>
            </div>
            <div class="col-sm-4   ">
                <p class="ml-5 mr-5">
                    <b>&nbsp;&nbsp;&nbsp;&nbsp;ขั้นตอนที่ 3 </b>
                        เมื่อเข้าสู่ระบบแล้วท่านจะพบกับหน้าเชื่อมต่อไลน์
                        ให้ท่านปฎิบัติตามขั้นตอนดังนี้<br />
                         1. เลือก "<b>รับการแจ้งเตือนแบบตัวต่อตัวจาก LINE Notify</b>"<br />
                         2. กดปุ่ม "<b>เห็นด้วยและเชื่อมต่อ</b>"
                </p>
                <div class="text-center">
                    <img src="../assets/regisline.jpg" width="70%" style="text-align: center;">
                </div>
            </div>
            <div class="col-sm-4">
                <p class="ml-5 mr-5">
                    <b>&nbsp;&nbsp;&nbsp;&nbsp;ขั้นตอนที่ 4 </b> ตรวจสอบความถูกต้อง<br>
                    หากการเชื่อมต่อไลน์สำเร็จท่านจะได้รับข้อความแจ้งเตือนผ่านทาง LINE Notify ดังรูป
                </p>
                <div class="text-center">
                    <img src="../assets/linesuccess.jpg" width="70%" style="text-align: center;">
                </div>
                <p class="ml-5 mr-5">
                    <b>&nbsp;&nbsp;&nbsp;&nbsp;ขั้นตอนที่ 5 </b> ลงทะเบียนไลน์กับบ้านของท่าน<br>
                    กรอกบ้านเลขที่ของท่านแล้วกดปุ่ม "ลงทะเบียน"
                </p>
                <div class="text-center">
                    <img src="../assets/registerhome.png" width="70%" style="text-align: center;">
                </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import QrcodeVue from 'qrcode.vue'

export default {
  components: {
    QrcodeVue
  }
}
</script>

<style>
.flex-box {
  padding-left: 4%;
}

.box {
  width: 120px;
  height: 120px;
  font-size: 50px;
  margin: 2%;
  cursor: pointer;
}

.box span {
  font-size: 30px;
}

@media only screen and (max-width: 320px) {
  .box {
    width: 95px;
    height: 95px;
    font-size: 40px;
    margin: 2%;
    cursor: pointer;
  }

  .box span {
    font-size: 18px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/linenoti.vue